import React from "react";
import { CloseIcon } from "@icarius-icons";
import { Dialog, DialogTitle, DialogContent, Typography, List, ListItem } from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";

const CollaboratorsDialog = (props) => {

  const {
    open,
    collaborators,
    handleClose,
  } = props;
  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      maxWidth={"sm"}
      fullWidth
      scroll={"paper"}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("bankSettingsCollaboratorsWithThisBank")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingBottom: 30 }}>
        {
          collaborators.length > 0 &&
          <List className="list-round-container">
            {
              collaborators.map(collaborator =>
                <ListItem>
                  <Typography align="center" variant="h6" className="whiteText" style={{ fontWeight: 100, fontSize: 16 }}>
                    {`${collaborator.name} (${collaborator.code})`}
                  </Typography>
                </ListItem>
              )
            }
          </List>
        }
        {
          collaborators.length === 0 &&
          <Typography align="center" variant="h6" className="whiteText" style={{ fontWeight: 100, fontSize: 16 }}>
            {getLocalizedString("bankSettingsNoAssociatedCollaborator")}
          </Typography>
        }
      </DialogContent>
    </Dialog>
  );
}

export default CollaboratorsDialog;